import { render, staticRenderFns } from "./DeliverableCard.vue?vue&type=template&id=2839f1f1&scoped=true&"
import script from "./DeliverableCard.vue?vue&type=script&lang=js&"
export * from "./DeliverableCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableCard.vue?vue&type=style&index=0&id=2839f1f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839f1f1",
  null
  
)

export default component.exports